import { render, staticRenderFns } from "./CategoryDeleteModal.vue?vue&type=template&id=393e90e8&scoped=true"
import script from "./CategoryDeleteModal.vue?vue&type=script&lang=js"
export * from "./CategoryDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393e90e8",
  null
  
)

export default component.exports